module.exports = __webpack_public_path__ + "static/team_2-e54d6051fe598980de55a6d21bf66541.jpg";